export const amber = {
  100: '#413417',
  200: '#705111',
  300: '#A06F0C',
  400: '#CF8C06',
  500: '#FFAA00',
  600: '#FFBB33',
  700: '#FFCC66',
  800: '#FFDD99',
  900: '#FFEECC',
} as const;
